<template>
<div id="ihealth-layout" class="theme-blue">
<!-- main body area -->
<div class="main p-2 py-3 p-xl-5">
    <!-- Body: Body -->
    <div class="body d-flex p-0 p-xl-5">
        <div class="container-xxl">
            <div class="row g-0">
                <div class="col-lg-12 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
                    <div class="w-100 p-3 p-md-5 card border-0 bg-dark text-light" style="max-width: 32rem;">
                     
                      <!-- Form -->
                      <form @submit.prevent="resetPassword" class="row g-1 p-3 p-md-4">
                        <div class="col-12 text-center mb-5">
                          <h1 class="mb-3">Şifrə təyini</h1>
                          <span>Zəhmət olmasa, hesabınız üçün yeni şifrə daxil edin.</span>
                        </div>

                        <!-- New Password -->
                        <div class="col-12">
                          <div class="mb-2">
                            <label class="form-label">Yeni Şifrə</label>
                            <input v-model="newPassword" v-validate="{ required: true, min: 8}" name="newpasswordfield" type="password" class="form-control form-control-lg" placeholder="Yeni şifrəni daxil edin">
                            <span class="inputError">{{ errors.first('newpasswordfield') }}</span>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="mb-2">
                            <label class="form-label">Şifrəni Təkrarla</label>
                            <input v-model="confirmPassword" v-validate="{ required: true, is: newPassword}" name="confirmpasswordfield" type="password" class="form-control form-control-lg" placeholder="Şifrəni təkrar daxil edin">
                            <span class="inputError">{{ errors.first('confirmpasswordfield') }}</span>
                          </div>
                        </div>

                        <!-- Change the password -->
                        <div class="col-12 text-center mt-4">
                          <button type="submit" :disabled="loading" class="btn btn-lg btn-block btn-light lift">Təsdiqlə</button>
                        </div>
                      </form>
                      <!-- End Form -->
                        
                    </div>
                </div>
            </div> <!-- End Row -->
        </div>
    </div>
</div>
</div>
</template>

<script>
import axios from "axios"
import store from '../store/'

export default {  
  name: 'SetPassword',
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      token: '',
      loading: false
    }
  },
  methods: {
    async resetPassword() {
      const validForm = await this.isFormValid()
      if (validForm) {
        if (!this.token) {
           this.$toast.error("Token tapılmadı! Linki yoxlayın.");
           return;
        }

        this.loading = true

        axios.post(store.getters.getUrl+'/Users/ResetPassword', {
          token: this.token, 
          newPassword: this.newPassword
        })
        .then(() => {
          this.$toast.success("Şifrə uğurla təyin edildi!")
          this.loading = false;
          this.$router.push('/login')
        })
        .catch(error => {
          this.$toast.error(error.response?.data?.title || "Serverdə səhvlik baş verdi!")
          this.loading = false;
        })
      } 
      else {
        this.$toast.error('Xanaları düzgün doldurun!')
      }
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    }
  },
  created() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.$toast.error("Token tapılmadı! Link natamamdır.");
    }
  }
}
</script>
